export default "__VITE_ASSET__ca992536__"